import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "settings",
    component: () => import("./pages/SettingsLayout.vue"),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      title: "settings.title",
      forceActiveMenu: "settings",
    },
    children: [
      {
        path: "",
        name: "settings",
        component: () => import("./pages/SystemSettings.vue"),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          title: "settings.email_config",
          forceActiveMenu: "settings",
        },
      },
      {
        path: "document-types",
        name: "settings-document-types",
        component: () => import("./pages/DocumentTypesSettings.vue"),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          title: "settings.document_types",
          forceActiveMenu: "settings",
        },
      },
    ],
  },
];
